import { isSameDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useMemo } from 'react';
import type { Timezones } from '../../types';

type Properties = {
  days: Date[];
  primaryTimezone: Timezones[number];
};

export const useShouldShowNowLine = ({ days, primaryTimezone }: Properties) =>
  useMemo(() => {
    const todayInPrimaryTimezone = toZonedTime(new Date(), primaryTimezone);
    return days.some((day) => isSameDay(day, todayInPrimaryTimezone));
  }, [days, primaryTimezone]);
